module.exports = __webpack_public_path__ + "img/store-volusion.a23931bb.svg";